// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__Pgqav","alert":"SettungsInbox_alert__1PRsL"};